import { render, staticRenderFns } from "./Task1.vue?vue&type=template&id=4210aac9&scoped=true&"
import script from "./Task1.vue?vue&type=script&lang=js&"
export * from "./Task1.vue?vue&type=script&lang=js&"
import style0 from "./Task1.vue?vue&type=style&index=0&id=4210aac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210aac9",
  null
  
)

export default component.exports